// import { useHover } from '@hooks';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ErrorIcon from '@mui/icons-material/Error';
import classes from './index.module.css';

export default function Method({ item = {}, handleMethodClick }) {
  const {
    time, title, icon, hover, subTitle,
  } = item;

  // const [hoverRef] = useHover();
  return (
    <div className={classes.method} onClick={() => handleMethodClick(item)}>
      <div className={classes.left}>
        <img src={icon} alt="" />
        <div className={classes.text}>
          <div className={classes.title}>
            {title}
            {hover && (
              <span className={classes.info_icon}>
                <ErrorIcon
                  fontSize="small"
                  sx={{
                    '&': {
                      color: '#5C5F62',
                    },
                  }}
                />
                <span className={classes.hover_text}>
                  <section className={classes.hover_text_tip}>
                    {hover}
                  </section>
                  <section className={classes.hover_triangle} />
                </span>
              </span>
            )}
            <span className={classes.sub_title}>{subTitle}</span>
          </div>
          <div className={classes.desc}>{time}</div>
        </div>

      </div>
      <div className={classes.right}>
        <ArrowForwardIosIcon
          fontSize="small"
        />
      </div>
    </div>
  );
}
